// Chakra imports
import {
    Box,
    Flex,
    Text,
    Image,
    Badge,
    HStack,
  } from "@chakra-ui/react";
  import Card from "components/card/Card.js";
  import React from "react";
  import { MdArrowUpward, MdArrowDownward } from "react-icons/md";
  import { Icon } from "@chakra-ui/react";
  import missionsIcon from 'assets/nav-icon/missions.png';
  
  export default function MissionStatCard(props) {
    const { 
      title, 
      value, 
      percentage, 
      isPositive = true, 
      iconColor = "#459CE9", // Couleur par défaut (bleu)
      subtitle = "vs semaine précédente" 
    } = props;
  
    // Couleurs selon le type de badge
    const badgeBg = isPositive ? "#EAF8FA" : "#FFEEF3";
    const badgeBorder = isPositive ? "rgba(41,186,205,0.2)" : "rgba(248,40,90,0.2)";
    const badgeText = isPositive ? "#29BACD" : "#F8285A";
    const badgeIcon = isPositive ? MdArrowUpward : MdArrowDownward;
  
    return (
      <Card p="20px" borderRadius="12px" border="1px solid #E5E5E5" position="relative" bg="white">
        <Flex gap="10px" alignItems="flex-start" h="100%">
          <Flex flex="1" flexDirection="column" gap="10px" minH="82px">
            <Text
              fontSize="14px"
              fontWeight="400"
              color="#656C7A"
              lineHeight="14px"
              fontFamily="Poppins, sans-serif">
              {title}
            </Text>
            
            <Flex gap="10px" alignItems="flex-end">
              <Text
                fontSize="28px"
                fontWeight="600"
                color="#455879"
                lineHeight="30px"
                letterSpacing="-0.56px"
                fontFamily="Oswald, sans-serif">
                {typeof value === 'number' ? value.toLocaleString('fr-FR') : value}
              </Text>
              
              {percentage && (
                <Badge
                  bg={badgeBg}
                  border={`1px solid ${badgeBorder}`}
                  borderRadius="4px"
                  p="3px"
                  display="flex"
                  alignItems="center"
                  gap="5px"
                  h="auto">
                  <Icon
                    as={badgeIcon}
                    w="12px"
                    h="12px"
                    color={badgeText}
                  />
                  <Text
                    fontSize="12px"
                    fontWeight="500"
                    color={badgeText}
                    lineHeight="12px"
                    fontFamily="Poppins, sans-serif">
                    {percentage}
                  </Text>
                </Badge>
              )}
            </Flex>
            
            <Flex gap="10px" alignItems="center" w="100%">
              <Text
                fontSize="12px"
                fontWeight="400"
                color="#656C7A"
                lineHeight="14px"
                fontFamily="Poppins, sans-serif"
                whiteSpace="pre-wrap">
                {subtitle}
              </Text>
            </Flex>
          </Flex>
          
          <Box
            position="absolute"
            top="20px"
            right="20px"
            w="24px"
            h="24px">
            <Image 
              src={missionsIcon} 
              w="24px" 
              h="24px" 
              alt="icon"
              sx={{
                filter: iconColor === "#459CE9" ? "none" : 
                  iconColor === "#29BACD" ? "brightness(0) saturate(100%) invert(67%) sepia(89%) saturate(1234%) hue-rotate(150deg) brightness(95%) contrast(95%)" :
                  iconColor === "#F8285A" ? "brightness(0) saturate(100%) invert(30%) sepia(95%) saturate(1234%) hue-rotate(320deg) brightness(95%) contrast(95%)" :
                  iconColor === "#7239EA" ? "brightness(0) saturate(100%) invert(45%) sepia(96%) saturate(1234%) hue-rotate(250deg) brightness(95%) contrast(95%)" :
                  "none"
              }}
            />
          </Box>
        </Flex>
      </Card>
    );
  }